define("settings/components/subscription-overview", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "lodash", "later/utils/constants", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _lodash, _constants, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"later/utils/constants",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{!
    Note: disabled if showCreatorCard check June 2023.
    Kept in the template so that we can refactor this to promote Growth when Starter removed.
  }}
  {{#if false}}
    <div class="tAC--planCard">
      {{! Current Plan: Free }}
      <div class="tAC--planCard__item">
        <div class="tAC--planCard__header">
          <h3 class="tAC--planCard__title">{{t "shared_words.free"}}</h3>
          <div class="tAC--planCard__label">{{t "account.overview.creator_card.current_plan"}}</div>
        </div>
        <ul class="tAC--planCard__ul">
          <li class="tAC--planCard__li u--text--bold">
            {{t "account.overview.creator_card.missing.title"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "delete-circle" class="o--icon tAC--planCard__icon tAC--planCard__icon--warning"}}
            {{t "account.overview.creator_card.missing.campaigns"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "delete-circle" class="o--icon tAC--planCard__icon tAC--planCard__icon--warning"}}
            {{t "account.overview.creator_card.missing.media_kit"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "delete-circle" class="o--icon tAC--planCard__icon tAC--planCard__icon--warning"}}
            {{t "account.overview.creator_card.missing.linkinbio"}}
          </li>
        </ul>
      </div>
      {{! Suggested Plan: Creator }}
      <div class="tAC--planCard__item tAC--planCard__item--creator">
        <div class="tAC--planCard__header">
          <h3 class="tAC--planCard__title">{{t "shared_words.creator"}}</h3>
          <div class="tAC--planCard__label">
            {{svg-jar "star" class="o--icon--sm o--icon--white"}}
            {{t "account.overview.creator_card.suggested"}}
          </div>
          <div class="tAC--planCard_price">
            <span class="u--text--strike">{{t "shared_words.$" amount="15"}}</span>
            <span class="u--text--hair u--text--sm">{{t "shared_phrases.usd_month"}}</span>
            {{svg-jar "arrow-right" class="o--icon o--icon--light u--m__lr__xs"}}
            <span>{{t "shared_phrases.try_free"}}</span>
          </div>
        </div>
        <ul class="tAC--planCard__ul">
  
          <li class="tAC--planCard__li u--text--bold">
            {{t "account.overview.creator_card.highlights.title"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "creator-find-campaign" class="o--icon tAC--planCard__icon tAC--planCard__icon--hl"}}
            {{t "account.overview.creator_card.highlights.campaigns"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "media-kit" class="o--icon tAC--planCard__icon tAC--planCard__icon--hl"}}
            {{t "account.overview.creator_card.highlights.media_kit"}}
          </li>
          <li class="tAC--planCard__li">
            {{svg-jar "linkin-bio" class="o--icon tAC--planCard__icon tAC--planCard__icon--hl"}}
            {{t "account.overview.creator_card.highlights.linkinbio"}}
  
          </li>
        </ul>
        <Shared::Button::Upgrade
          @additional="block"
          @feature="creator"
          @location="subscription overview creator card"
          @seamlessCheckoutSuccessCallback={{this.redirectCreators}}
          @variant="unstyled"
          class="tAC--planCard__button"
        />
      </div>
    </div>
    <hr class="tAC--section__divider" />
  {{else}}
    <Section::ItemWrapper>
      <Section::ItemDetails class="tAC--plan" data-test-id="overview">
        <PlanImage @planType={{this.subscriptionPlan.planType}} @shouldShowImage={{this.isOnLegacyPlan}} />
        <div class="tAC--plan__detail">
          {{#if (or this.hasActiveCancelledSubscription this.hasUpcomingDowngrade)}}
            <p class="u--text--lg u--m__b__sm" data-test-id="downgrade plan name">
              <span class="u--text--light u--text--strike">{{this.name}}</span>
  
              {{this.upcomingPlanName}}
  
              {{#if this.currentAccount.hasActiveTrial}}
                <span class="tAC--plan__label u--float--right" data-test-id="downgrade trial days">
                  {{t "account.trial_plan_count" count=this.currentAccount.trialDaysRemaining}}
                </span>
              {{/if}}
            </p>
            {{#unless this.isMobileSubscription}}
              {{#if this.getDiscount.isRunning}}
                <p>
                  {{html-safe (t "account.overview.subscription_overview.loading")}}
                </p>
              {{else if (and this.hasActiveCancelledSubscription this.currentAccount.hasActiveTrial)}}
                <p data-test-id="trial cancelled">
                  {{html-safe
                    (t
                      "account.overview.subscription_overview.cancelled_trial"
                      planName=this.name
                      count=this.currentAccount.trialDaysRemaining
                      date=this.subscription.activeUntil
                    )
                  }}
                </p>
              {{else if (and this.hasUpcomingDowngrade this.currentAccount.hasActiveTrial)}}
                {{#if this.hasDiscount}}
                  <p data-test-id="trial downgraded discount">
                    {{html-safe
                      (t
                        "account.overview.subscription_overview.downgraded_trial_discounted"
                        count=this.currentAccount.trialDaysRemaining
                        interval=this.upcomingPlan.interval
                        date=this.subscription.activeUntil
                        planName=this.name
                        upcomingPlanName=this.upcomingPlanName
                        futureAmount=this.nextAmountCharged
                        discount=(format-currency this.discountAmount)
                      )
                    }}
                    {{this.taxAmountMessage}}
                  </p>
                {{else}}
                  <p data-test-id="trial downgraded">
                    {{html-safe
                      (t
                        "account.overview.subscription_overview.downgraded_trial"
                        count=this.currentAccount.trialDaysRemaining
                        date=this.subscription.activeUntil
                        planName=this.name
                        upcomingPlanName=this.upcomingPlanName
                        amount=this.nextAmountCharged
                        interval=this.upcomingPlan.interval
                      )
                    }}
                    {{this.taxAmountMessage}}
                  </p>
                {{/if}}
              {{else}}
                <p data-test-id="downgraded">
                  {{html-safe
                    (t
                      "account.overview.subscription_overview.active_until"
                      planName=this.name
                      upcomingPlanName=this.upcomingPlanName
                      date=this.subscription.activeUntil
                    )
                  }}
                </p>
              {{/if}}
            {{/unless}}
          {{else}}
            <p class="u--text--lg u--m__b__sm qa--accountSettings_currentPlan_title" data-test-id="plan name">
              {{this.name}}
              {{#if this.currentAccount.hasActiveTrial}}
                <span class="tAC--plan__label u--float--right" data-test-id="trial days">
                  {{t "account.trial_plan_count" count=this.currentAccount.trialDaysRemaining}}
                </span>
              {{/if}}
            </p>
            {{#unless this.isMobileSubscription}}
              {{#if this.getDiscount.isRunning}}
                <p>
                  {{html-safe (t "account.overview.subscription_overview.loading")}}
                </p>
              {{else if this.isEligibleForTrial}}
                <p data-test-id="trial eligible">
                  {{html-safe (t "account.overview.subscription_overview.trial_details")}}
                </p>
              {{else if (and this.isPaidPlan (not this.hasCustomPlan))}}
                {{#if this.currentAccount.hasActiveTrial}}
                  {{#if this.hasDiscount}}
                    <p data-test-id="trial discount">
                      {{html-safe
                        (t
                          "account.overview.subscription_overview.renewal_date_trial_discounted"
                          count=this.currentAccount.trialDaysRemaining
                          interval=(if
                            this.hasUpcomingIntervalDowngrade this.upcomingPlan.interval this.subscriptionPlan.interval
                          )
                          date=this.renewalDate
                          planName=this.name
                          futureAmount=this.nextAmountCharged
                          discount=(format-currency this.discountAmount)
                        )
                      }}
                      {{this.taxAmountMessage}}
                    </p>
                  {{else}}
                    <p data-test-id="trial renewal date">
                      {{this.trialRenewalMessage}}
                      {{this.taxAmountMessage}}
                    </p>
                  {{/if}}
                {{else if this.isEnterpriseSubscription}}
                  {{! show nothing }}
                {{else if (and this.hasDiscount (not this.hasDowngradedAfterDiscountRemoval))}}
                  <p data-test-id="discount">
                    {{html-safe
                      (t
                        "account.overview.subscription_overview.renewal_date_discounted"
                        interval=this.subscriptionPlan.normalizedInterval
                        date=this.renewalDate
                        planName=this.name
                        futureAmount=this.nextAmountCharged
                        discount=(format-currency this.discountAmount)
                      )
                    }}
                    {{this.taxAmountMessage}}
                  </p>
                {{else}}
                  <p data-test-id="renewal date">
                    {{html-safe
                      (t
                        "account.overview.subscription_overview.renewal_date"
                        interval=this.subscriptionPlan.normalizedInterval
                        date=this.renewalDate
                        planName=this.name
                        amount=this.nextAmountCharged
                      )
                    }}
                    {{this.taxAmountMessage}}
                  </p>
                {{/if}}
              {{else if (and this.hasDiscount (not this.hasDowngradedAfterDiscountRemoval))}}
                <p data-test-id="discount">
                  {{html-safe
                    (t
                      "account.overview.subscription_overview.renewal_date_discounted"
                      interval=this.subscriptionPlan.normalizedInterval
                      date=this.renewalDate
                      futureAmount=this.nextAmountCharged
                      discount=(format-currency this.discountAmount)
                    )
                  }}
                  {{this.taxAmountMessage}}
                </p>
              {{else if this.isPaidPlan}}
                <p data-test-id="renewal date">
                  {{html-safe
                    (t
                      "account.overview.subscription_overview.renewal_date"
                      interval=this.subscriptionPlan.normalizedInterval
                      date=this.renewalDate
                      amount=this.nextAmountCharged
                    )
                  }}
                  {{this.taxAmountMessage}}
                </p>
              {{/if}}
            {{/unless}}
  
          {{/if}}
        </div>
      </Section::ItemDetails>
      {{#if this.isMobileSubscription}}
        <Shared::Ui::MobileRedirectPrompt class="tAC--section__card" />
      {{else if (not this.isEnterpriseSubscription)}}
        <SubscriptionOverview::Action
          @canReactivatePlan={{this.canReactivatePlan}}
          @canShowCancelTrial={{this.canShowCancelTrial}}
          @canUpgrade={{this.canUpgrade}}
          @cancelTrial={{this.cancelTrial}}
          @hasActiveCancelledSubscription={{this.hasActiveCancelledSubscription}}
          @hasActiveTrial={{this.currentAccount.hasActiveTrial}}
          @isAccountOwner={{this.isAccountOwner}}
          @isFreeEligibleForTrial={{this.isFreeEligibleForTrial}}
          @isNewSubscriber={{this.isNewSubscriber}}
          @reactivatePlan={{this.reactivatePlan}}
          @subscription={{this.subscription}}
          @trackChangePlan={{this.trackChangePlan}}
          @trackClickedTraining={{this.trackClickedTraining}}
        />
      {{/if}}
  
    </Section::ItemWrapper>
  {{/if}}
  */
  {
    "id": "XU5RCLG5",
    "block": "[[[41,false,[[[1,\"  \"],[10,0],[14,0,\"tAC--planCard\"],[12],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tAC--planCard__item\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--planCard__header\"],[12],[1,\"\\n        \"],[10,\"h3\"],[14,0,\"tAC--planCard__title\"],[12],[1,[28,[35,1],[\"shared_words.free\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--planCard__label\"],[12],[1,[28,[35,1],[\"account.overview.creator_card.current_plan\"],null]],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"tAC--planCard__ul\"],[12],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.missing.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"delete-circle\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--warning\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.missing.campaigns\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"delete-circle\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--warning\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.missing.media_kit\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"delete-circle\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--warning\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.missing.linkinbio\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[1,\"    \"],[10,0],[14,0,\"tAC--planCard__item tAC--planCard__item--creator\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"tAC--planCard__header\"],[12],[1,\"\\n        \"],[10,\"h3\"],[14,0,\"tAC--planCard__title\"],[12],[1,[28,[35,1],[\"shared_words.creator\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--planCard__label\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"star\"],[[\"class\"],[\"o--icon--sm o--icon--white\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.suggested\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"tAC--planCard_price\"],[12],[1,\"\\n          \"],[10,1],[14,0,\"u--text--strike\"],[12],[1,[28,[35,1],[\"shared_words.$\"],[[\"amount\"],[\"15\"]]]],[13],[1,\"\\n          \"],[10,1],[14,0,\"u--text--hair u--text--sm\"],[12],[1,[28,[35,1],[\"shared_phrases.usd_month\"],null]],[13],[1,\"\\n          \"],[1,[28,[35,2],[\"arrow-right\"],[[\"class\"],[\"o--icon o--icon--light u--m__lr__xs\"]]]],[1,\"\\n          \"],[10,1],[12],[1,[28,[35,1],[\"shared_phrases.try_free\"],null]],[13],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,\"ul\"],[14,0,\"tAC--planCard__ul\"],[12],[1,\"\\n\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li u--text--bold\"],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.highlights.title\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"creator-find-campaign\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--hl\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.highlights.campaigns\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"media-kit\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--hl\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.highlights.media_kit\"],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,\"li\"],[14,0,\"tAC--planCard__li\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"linkin-bio\"],[[\"class\"],[\"o--icon tAC--planCard__icon tAC--planCard__icon--hl\"]]]],[1,\"\\n          \"],[1,[28,[35,1],[\"account.overview.creator_card.highlights.linkinbio\"],null]],[1,\"\\n\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n      \"],[8,[39,3],[[24,0,\"tAC--planCard__button\"]],[[\"@additional\",\"@feature\",\"@location\",\"@seamlessCheckoutSuccessCallback\",\"@variant\"],[\"block\",\"creator\",\"subscription overview creator card\",[30,0,[\"redirectCreators\"]],\"unstyled\"]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[14,0,\"tAC--section__divider\"],[12],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[8,[39,4],null,null,[[\"default\"],[[[[1,\"\\n    \"],[8,[39,5],[[24,0,\"tAC--plan\"],[24,\"data-test-id\",\"overview\"]],null,[[\"default\"],[[[[1,\"\\n      \"],[8,[39,6],null,[[\"@planType\",\"@shouldShowImage\"],[[30,0,[\"subscriptionPlan\",\"planType\"]],[30,0,[\"isOnLegacyPlan\"]]]],null],[1,\"\\n      \"],[10,0],[14,0,\"tAC--plan__detail\"],[12],[1,\"\\n\"],[41,[28,[37,7],[[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"hasUpcomingDowngrade\"]]],null],[[[1,\"          \"],[10,2],[14,0,\"u--text--lg u--m__b__sm\"],[14,\"data-test-id\",\"downgrade plan name\"],[12],[1,\"\\n            \"],[10,1],[14,0,\"u--text--light u--text--strike\"],[12],[1,[30,0,[\"name\"]]],[13],[1,\"\\n\\n            \"],[1,[30,0,[\"upcomingPlanName\"]]],[1,\"\\n\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[1,\"              \"],[10,1],[14,0,\"tAC--plan__label u--float--right\"],[14,\"data-test-id\",\"downgrade trial days\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"account.trial_plan_count\"],[[\"count\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[41,[30,0,[\"getDiscount\",\"isRunning\"]],[[[1,\"              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.loading\"],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,10],[[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]]],null],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"trial cancelled\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.cancelled_trial\"],[[\"planName\",\"count\",\"date\"],[[30,0,[\"name\"]],[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"subscription\",\"activeUntil\"]]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,10],[[30,0,[\"hasUpcomingDowngrade\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]]],null],[[[41,[30,0,[\"hasDiscount\"]],[[[1,\"                \"],[10,2],[14,\"data-test-id\",\"trial downgraded discount\"],[12],[1,\"\\n                  \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.downgraded_trial_discounted\"],[[\"count\",\"interval\",\"date\",\"planName\",\"upcomingPlanName\",\"futureAmount\",\"discount\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"upcomingPlan\",\"interval\"]],[30,0,[\"subscription\",\"activeUntil\"]],[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[30,0,[\"nextAmountCharged\"]],[28,[37,11],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n                  \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],[[[1,\"                \"],[10,2],[14,\"data-test-id\",\"trial downgraded\"],[12],[1,\"\\n                  \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.downgraded_trial\"],[[\"count\",\"date\",\"planName\",\"upcomingPlanName\",\"amount\",\"interval\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[30,0,[\"subscription\",\"activeUntil\"]],[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[30,0,[\"nextAmountCharged\"]],[30,0,[\"upcomingPlan\",\"interval\"]]]]]],null]],[1,\"\\n                  \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]]]],[]],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"downgraded\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.active_until\"],[[\"planName\",\"upcomingPlanName\",\"date\"],[[30,0,[\"name\"]],[30,0,[\"upcomingPlanName\"]],[30,0,[\"subscription\",\"activeUntil\"]]]]]],null]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]]]],[]]]],[]]]],[]],null]],[]],[[[1,\"          \"],[10,2],[14,0,\"u--text--lg u--m__b__sm qa--accountSettings_currentPlan_title\"],[14,\"data-test-id\",\"plan name\"],[12],[1,\"\\n            \"],[1,[30,0,[\"name\"]]],[1,\"\\n\"],[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[1,\"              \"],[10,1],[14,0,\"tAC--plan__label u--float--right\"],[14,\"data-test-id\",\"trial days\"],[12],[1,\"\\n                \"],[1,[28,[35,1],[\"account.trial_plan_count\"],[[\"count\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]]]]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],null],[1,\"          \"],[13],[1,\"\\n\"],[41,[51,[30,0,[\"isMobileSubscription\"]]],[[[41,[30,0,[\"getDiscount\",\"isRunning\"]],[[[1,\"              \"],[10,2],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.loading\"],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isEligibleForTrial\"]],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"trial eligible\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.trial_details\"],null]],null]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[28,[37,10],[[30,0,[\"isPaidPlan\"]],[28,[37,12],[[30,0,[\"hasCustomPlan\"]]],null]],null],[[[41,[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[[[41,[30,0,[\"hasDiscount\"]],[[[1,\"                  \"],[10,2],[14,\"data-test-id\",\"trial discount\"],[12],[1,\"\\n                    \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.renewal_date_trial_discounted\"],[[\"count\",\"interval\",\"date\",\"planName\",\"futureAmount\",\"discount\"],[[30,0,[\"currentAccount\",\"trialDaysRemaining\"]],[52,[30,0,[\"hasUpcomingIntervalDowngrade\"]],[30,0,[\"upcomingPlan\",\"interval\"]],[30,0,[\"subscriptionPlan\",\"interval\"]]],[30,0,[\"renewalDate\"]],[30,0,[\"name\"]],[30,0,[\"nextAmountCharged\"]],[28,[37,11],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n                    \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]],[[[1,\"                  \"],[10,2],[14,\"data-test-id\",\"trial renewal date\"],[12],[1,\"\\n                    \"],[1,[30,0,[\"trialRenewalMessage\"]]],[1,\"\\n                    \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                  \"],[13],[1,\"\\n\"]],[]]]],[]],[[[41,[30,0,[\"isEnterpriseSubscription\"]],[[],[]],[[[41,[28,[37,10],[[30,0,[\"hasDiscount\"]],[28,[37,12],[[30,0,[\"hasDowngradedAfterDiscountRemoval\"]]],null]],null],[[[1,\"                \"],[10,2],[14,\"data-test-id\",\"discount\"],[12],[1,\"\\n                  \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.renewal_date_discounted\"],[[\"interval\",\"date\",\"planName\",\"futureAmount\",\"discount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[30,0,[\"name\"]],[30,0,[\"nextAmountCharged\"]],[28,[37,11],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n                  \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                \"],[13],[1,\"\\n\"]],[]],[[[1,\"                \"],[10,2],[14,\"data-test-id\",\"renewal date\"],[12],[1,\"\\n                  \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.renewal_date\"],[[\"interval\",\"date\",\"planName\",\"amount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[30,0,[\"name\"]],[30,0,[\"nextAmountCharged\"]]]]]],null]],[1,\"\\n                  \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n                \"],[13],[1,\"\\n              \"]],[]]]],[]]]],[]]]],[]],[[[41,[28,[37,10],[[30,0,[\"hasDiscount\"]],[28,[37,12],[[30,0,[\"hasDowngradedAfterDiscountRemoval\"]]],null]],null],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"discount\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.renewal_date_discounted\"],[[\"interval\",\"date\",\"futureAmount\",\"discount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[30,0,[\"nextAmountCharged\"]],[28,[37,11],[[30,0,[\"discountAmount\"]]],null]]]]],null]],[1,\"\\n                \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n              \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"isPaidPlan\"]],[[[1,\"              \"],[10,2],[14,\"data-test-id\",\"renewal date\"],[12],[1,\"\\n                \"],[1,[28,[35,9],[[28,[37,1],[\"account.overview.subscription_overview.renewal_date\"],[[\"interval\",\"date\",\"amount\"],[[30,0,[\"subscriptionPlan\",\"normalizedInterval\"]],[30,0,[\"renewalDate\"]],[30,0,[\"nextAmountCharged\"]]]]]],null]],[1,\"\\n                \"],[1,[30,0,[\"taxAmountMessage\"]]],[1,\"\\n              \"],[13],[1,\"\\n            \"]],[]],null]],[]]]],[]]]],[]]]],[]]]],[]],null],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"],[41,[30,0,[\"isMobileSubscription\"]],[[[1,\"      \"],[8,[39,13],[[24,0,\"tAC--section__card\"]],null,null],[1,\"\\n\"]],[]],[[[41,[28,[37,12],[[30,0,[\"isEnterpriseSubscription\"]]],null],[[[1,\"      \"],[8,[39,14],null,[[\"@canReactivatePlan\",\"@canShowCancelTrial\",\"@canUpgrade\",\"@cancelTrial\",\"@hasActiveCancelledSubscription\",\"@hasActiveTrial\",\"@isAccountOwner\",\"@isFreeEligibleForTrial\",\"@isNewSubscriber\",\"@reactivatePlan\",\"@subscription\",\"@trackChangePlan\",\"@trackClickedTraining\"],[[30,0,[\"canReactivatePlan\"]],[30,0,[\"canShowCancelTrial\"]],[30,0,[\"canUpgrade\"]],[30,0,[\"cancelTrial\"]],[30,0,[\"hasActiveCancelledSubscription\"]],[30,0,[\"currentAccount\",\"hasActiveTrial\"]],[30,0,[\"isAccountOwner\"]],[30,0,[\"isFreeEligibleForTrial\"]],[30,0,[\"isNewSubscriber\"]],[30,0,[\"reactivatePlan\"]],[30,0,[\"subscription\"]],[30,0,[\"trackChangePlan\"]],[30,0,[\"trackClickedTraining\"]]]],null],[1,\"\\n    \"]],[]],null]],[]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\"]],[]]]],[],false,[\"if\",\"t\",\"svg-jar\",\"shared/button/upgrade\",\"section/item-wrapper\",\"section/item-details\",\"plan-image\",\"or\",\"unless\",\"html-safe\",\"and\",\"format-currency\",\"not\",\"shared/ui/mobile-redirect-prompt\",\"subscription-overview/action\"]]",
    "moduleName": "settings/components/subscription-overview.hbs",
    "isStrictMode": false
  });
  let SubscriptionOverviewComponent = _exports.default = (_class = class SubscriptionOverviewComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "cancellation", _descriptor2, this);
      _initializerDefineProperty(this, "intl", _descriptor3, this);
      _initializerDefineProperty(this, "locale", _descriptor4, this);
      _initializerDefineProperty(this, "payment", _descriptor5, this);
      _initializerDefineProperty(this, "router", _descriptor6, this);
      _initializerDefineProperty(this, "settings", _descriptor7, this);
      _initializerDefineProperty(this, "subscriptions", _descriptor8, this);
      _initializerDefineProperty(this, "taxId", _descriptor9, this);
      _defineProperty(this, "getDiscount", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield Promise.allSettled([this.subscriptions.getSubscriptionDiscount(), this.getTaxId()]);
        }
      }), null, "getDiscount", null));
      _defineProperty(this, "reactivatePlan", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          yield this.settings.reactivateCancelledPlan.perform(this.subscription);
          yield this.getDiscount.perform();
        }
      }), null, "reactivatePlan", null));
      this.getDiscount.perform();

      //Note: watches all subscription changes in order to capture plan upgrade/downgrade, and addon changes
      this.subscriptions.on('update:subscription', this.getDiscount.perform);
    }
    get baseName() {
      return this.subscriptionPlan.displayName;
    }
    get canReactivatePlan() {
      return this.subscriptionPlan.active;
    }
    get canUpgrade() {
      return this.subscriptions.canUpgrade;
    }
    get canShowCancelTrial() {
      return this.args.canShowCancelTrial && !this.subscriptions.isOnCardlessTrial;
    }
    get currentAccount() {
      return this.auth.currentAccount;
    }
    get discount() {
      return this.subscriptions.discount;
    }
    get discountAmount() {
      const discountAppliesPlanOnly = (0, _utils.isPresent)(this.discount?.appliesTo);
      if (discountAppliesPlanOnly) {
        const planAmount = this.upcomingPlan?.amount ?? this.subscriptionPlan.amount;
        const planDiscount = this.discount.amountOff ?? planAmount * (this.discount.percentOff / 100);
        return Math.min(planAmount, planDiscount);
      }
      return this.discount.discountAmount;
    }
    get hasActiveCancelledSubscription() {
      return this.currentAccount.hasActiveCancelledSubscription;
    }
    get hasCustomPlan() {
      return this.currentAccount.hasCustomPlan;
    }
    get hasDiscount() {
      return Boolean(this.discount?.discountAmount);
    }
    get hasDowngradedAfterDiscountRemoval() {
      const hasIntervalDowngrade = this.hasUpcomingIntervalDowngrade && this.subscription.planModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasSocialSetDowngrade = this.hasUpcomingSocialSetDowngrade && this.subscription.socialSetsModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      const hasUserDowngrade = this.hasUpcomingUserDowngrade && this.subscription.usersModifiedTime >= _constants.DOWNGRADE_DISCOUNT_REMOVAL_CUTOFF;
      return hasIntervalDowngrade || hasSocialSetDowngrade || hasUserDowngrade;
    }
    get hasUpcomingDowngrade() {
      return this.subscriptions.hasUpcomingDowngrade;
    }
    get hasUpcomingIntervalDowngrade() {
      return this.subscriptions.hasUpcomingIntervalDowngrade;
    }
    get hasUpcomingSocialSetDowngrade() {
      const currentQuantity = this.subscription.additionalSocialSets;
      const upcomingQuantity = this.subscription.upcomingSocialSetChanges?.quantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity > upcomingQuantity;
    }
    get hasUpcomingUserDowngrade() {
      const currentQuantity = this.subscription.additionalUsers;
      const upcomingQuantity = this.subscription.upcomingUserChanges?.quantity;
      return (0, _utils.isPresent)(currentQuantity) && (0, _utils.isPresent)(upcomingQuantity) && currentQuantity > upcomingQuantity;
    }
    get hasVIPPlan() {
      return !this.isStripeCustomer && !(0, _lodash.isEmpty)(this.subscription);
    }
    get isAccountOwner() {
      return this.settings.isAccountOwner;
    }
    get isEligibleForTrial() {
      return this.currentAccount.canTrialPlan;
    }
    get isFreeEligibleForTrial() {
      return !this.currentAccount.hasActiveSubscription && this.isEligibleForTrial;
    }
    get isOnLegacyPlan() {
      return this.currentAccount.isOnLegacyPlan;
    }
    get isStripeCustomer() {
      return this.currentAccount.isStripeCustomer;
    }
    get isNewSubscriber() {
      return this.settings.isNewSubscriber;
    }
    get isMobileSubscription() {
      return this.subscriptions.isMobileSubscription;
    }
    get isEnterpriseSubscription() {
      return this.subscriptions.isEnterpriseSubscription;
    }
    get isPaidPlan() {
      return this.subscriptions.isPaid;
    }
    get name() {
      if (this.currentAccount.hasActiveTrial) {
        return this.intl.t('account.trial_plan_name', {
          name: this.baseName
        });
      } else if (this.hasVIPPlan) {
        return this.intl.t('account.subscription.vip_plan');
      } else if (this.hasCustomPlan) {
        return this.intl.t('account.subscription.custom_plan');
      }
      return this.baseName;
    }
    get planType() {
      return this.subscriptions.planType;
    }
    get renewalDate() {
      return this.subscription?.renewalDate;
    }
    get subscription() {
      return this.subscriptions.subscription;
    }
    get subscriptionPlan() {
      return this.subscriptions.subscriptionPlan;
    }
    get upcomingPlan() {
      return this.subscriptions.upcomingSubscriptionPlan;
    }
    get upcomingPlanName() {
      if (this.hasUpcomingDowngrade || this.hasActiveCancelledSubscription) {
        return this.upcomingPlan?.displayName;
      }
      return null;
    }
    get nextAmountCharged() {
      const amount = this.shouldDisplayTaxAmount ? this.discount?.futureAmountIncludingTax : this.discount?.futureAmountBeforeTax;
      const amountFormatted = this.locale.formatCurrency(((amount ?? 0) / 100).toFixed(2));
      if (!amount) {
        return amountFormatted;
      }
      return this.shouldDisplayTaxAmount ? amountFormatted : this.intl.t('plans.checkout.plan.amount_plus_tax', {
        amount: amountFormatted
      });
    }
    get shouldDisplayTaxAmount() {
      return this.discount?.totalTaxAmounts?.some(taxAmount => {
        return taxAmount.tax_rate.tax_type === 'vat';
      });
    }
    get hasPendingTaxId() {
      return Boolean(this.taxId?.status === 'pending' || this.taxId?.status === 'unavailable');
    }
    get hasVerifiedTaxId() {
      return Boolean(this.taxId?.status === 'verified');
    }
    get taxAmountMessage() {
      if (!this.shouldDisplayTaxAmount) {
        return '';
      }
      if (this.hasPendingTaxId && this.discount.taxAmount === 0) {
        return this.intl.t('account.overview.subscription_overview.tax_id.vat_pending');
      } else if (this.hasVerifiedTaxId && this.discount.taxAmount === 0) {
        return this.intl.t('account.overview.subscription_overview.tax_id.vat_exempt');
      }
      const vatAmount = this.locale.formatCurrency(((this.discount?.taxAmount ?? 0) / 100).toFixed(2));
      return this.intl.t('account.overview.subscription_overview.tax_id.vat_included', {
        vatAmount
      });
    }
    get trialRenewalMessage() {
      if (this.subscriptions.isOnCardlessTrial) {
        return this.intl.t('account.overview.subscription_overview.renewal_date_trial_sourceless_trial', {
          date: this.renewalDate
        });
      }
      return this.intl.t('account.overview.subscription_overview.renewal_date_trial', {
        count: this.currentAccount.trialDaysRemaining,
        interval: this.hasUpcomingIntervalDowngrade ? this.upcomingPlan.interval : this.subscriptionPlan.interval,
        date: this.renewalDate,
        planName: this.name,
        amount: this.nextAmountCharged
      });
    }
    async getTaxId() {
      this.taxId = await this.payment.retrieveTaxIds.perform();
    }
    cancelTrial() {
      this.cancellation.startCancellationFlow.perform('subscription');
    }
    redirectCreators() {
      const group = this.auth.lastGroup;
      const socialIdentity = group.socialIdentities?.firstObject;
      if (group && socialIdentity) {
        this.router.transitionTo('cluster.partnerships.profile', group.slug, socialIdentity.id);
      } else if (group) {
        this.router.transitionTo('cluster.partnerships', group.slug);
      }
    }
    trackChangePlan() {
      this.settings.trackChangePlan.perform(this.subscription);
    }
    trackClickedTraining() {
      this.settings.trackClickedTraining.perform(this.subscription);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cancellation", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "locale", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "payment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "settings", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "subscriptions", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "taxId", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return undefined;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "cancelTrial", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "cancelTrial"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "redirectCreators", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "redirectCreators"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackChangePlan", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackChangePlan"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackClickedTraining", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackClickedTraining"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SubscriptionOverviewComponent);
});